import React, { useCallback, useState } from 'react';
import {
    getSmoothStepPath,
    BaseEdge,
    EdgeLabelRenderer,
    useReactFlow,
    MarkerType
} from '@xyflow/react';

const N8NEdge = (props) => {
    const {
        id,
        sourceX,
        sourceY,
        targetX,
        targetY,
        sourcePosition,
        targetPosition,
        data,
        markerEnd,
        selected
    } = props;

    const [hovered, setHovered] = useState(false)

    const [edgePath, labelX, labelY] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition
    });

    const { setEdges } = useReactFlow();

    const onEdgeDelete = useCallback(() => {
        setEdges(edges => edges.filter(edge => edge.id !== id));
    }, [id, setEdges]);

    const strokeColor = selected ? '#4A90D9' : hovered ? '#64748b' : '#94a3b8'

    return (
        <>
            {/* Invisible wider path for easier hover detection */}
            <path
                d={edgePath}
                fill="none"
                stroke="transparent"
                strokeWidth={16}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                style={{ cursor: 'pointer' }}
            />
            <BaseEdge
                path={edgePath}
                style={{
                    stroke: strokeColor,
                    strokeWidth: selected ? 2.5 : 1.5,
                    transition: 'stroke 0.15s ease, stroke-width 0.15s ease',
                    ...(selected && { strokeDasharray: '6 3', animation: 'dash-flow 0.3s linear infinite' }),
                }}
                markerEnd={markerEnd || { type: MarkerType.ArrowClosed, color: strokeColor }}
            />
            <EdgeLabelRenderer>
                <div
                    style={{
                        position: 'absolute',
                        transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
                        pointerEvents: 'all'
                    }}
                    className="nodrag nopan"
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                >
                    {data?.label && (
                        <span style={{
                            marginRight: 6,
                            color: '#475569',
                            fontSize: 11,
                            fontWeight: 500,
                            background: '#fff',
                            padding: '1px 5px',
                            borderRadius: 3,
                            border: '1px solid #e2e8f0',
                        }}>
                            {data.label}
                        </span>
                    )}
                    {(hovered || selected) && (
                        <button
                            onClick={onEdgeDelete}
                            title="Delete connection"
                            style={{
                                width: 20,
                                height: 20,
                                padding: 0,
                                color: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                background: '#ef4444',
                                cursor: 'pointer',
                                fontSize: 12,
                                lineHeight: '20px',
                                textAlign: 'center',
                                opacity: hovered ? 1 : 0,
                                transition: 'opacity 0.15s ease',
                            }}
                        >
                            ×
                        </button>
                    )}
                </div>
            </EdgeLabelRenderer>
        </>
    );
};

export default N8NEdge